import { compose } from 'ramda';
import { fromJS } from 'immutable';
export function parsePayload(consent) {
  return consent.update('payload', parseJSON);
}
var parseJSON = compose(fromJS, JSON.parse);
export function parseCustomerPayloads(customerDetails) {
  return customerDetails.update('consents', function (consents) {
    return consents.map(function (consent) {
      return consent.updateIn(['consent', 'payload'], parseJSON);
    });
  });
}
export function channelIdToJourneyType(channelId) {
  return {
    OBAISP: 'OBAISP',
    OBPISP: 'OBPISP',
    OBPISPBB: 'OBPISP',
    OBPISPSO: 'OBPISP',
    OBCBPII: 'OBCBPII',
    OBVRP: 'OBPISP'
  }[channelId];
}
export function hasChannel(arg) {
  return function (consent) {
    var channelId = consent.get('channelId');
    if (typeof arg === 'string') return channelId === arg;else return arg.indexOf(channelId) !== -1;
  };
}